export const CLUB_INFO_TOKENS = [
  { token: '{{club.name}}', label: 'Club Name' },
  { token: '{{club.slogan}}', label: 'Club Slogan' },
  { token: '{{club.email}}', label: 'Club Email' },
  { token: '{{club.website}}', label: 'Club Website' },
  { token: '{{club.phone}}', label: 'Club Phone' },
  { token: '{{club.city}}', label: 'Club City' },
  { token: '{{club.country}}', label: 'Club Country' },
];

export const MEETING_INFO_TOKENS = [
  { token: '{{meeting.location}}', label: 'Meeting Location' },
  { token: '{{meeting.dayOfWeek}}', label: 'Meeting Day Of Week' },
  { token: '{{meeting.frequency}}', label: 'Meeting Frequency' },
  { token: '{{meeting.time}}', label: 'Meeting Time' },
  { token: '{{meeting.mode}}', label: 'Meeting Mode' },
  { token: '{{meeting.address}}', label: 'Meeting Address' },
  { token: '{{meeting.mapLink}}', label: 'Meeting Map Link' },
  { token: '{{meeting.onlineLink}}', label: 'Online Meeting Link' },
  { token: '{{meeting.passcode}}', label: 'Meeting Passcode' },
  { token: '{{meeting.nextMeetingLink}}', label: 'Next Meeting Link' },
  { token: '{{meeting.nextMeetingAttendanceLink}}', label: 'Next Meeting Attendance Link' },
];

export const DATA_REFERENCE_TOKENS = [
  ...CLUB_INFO_TOKENS.map((item) => ({ ...item, group: 'Club' })),
  ...MEETING_INFO_TOKENS.map((item) => ({ ...item, group: 'Meeting' })),
];

export const appendToken = (text, token) => {
  if (!token) return text || '';
  const base = text || '';
  const spacer = base.length > 0 && !base.endsWith(' ') ? ' ' : '';
  return `${base}${spacer}${token}`;
};

const isEditableTextInput = (el) => {
  if (!el) return false;
  if (el.tagName === 'TEXTAREA') return true;
  if (el.tagName !== 'INPUT') return false;
  const textLikeTypes = ['text', 'search', 'url', 'email', 'tel'];
  return textLikeTypes.includes((el.type || '').toLowerCase());
};

const setNativeElementValue = (el, nextValue) => {
  if (!el) return;

  const proto = el.tagName === 'TEXTAREA'
    ? window.HTMLTextAreaElement?.prototype
    : window.HTMLInputElement?.prototype;

  const descriptor = proto ? Object.getOwnPropertyDescriptor(proto, 'value') : null;
  const setter = descriptor?.set;

  if (setter) {
    setter.call(el, nextValue);
    return;
  }

  el.value = nextValue;
};

export const applyInlineFormatToActiveField = (format) => {
  const el = document.activeElement;
  if (!isEditableTextInput(el)) return;

  const value = el.value || '';
  const start = typeof el.selectionStart === 'number' ? el.selectionStart : value.length;
  const end = typeof el.selectionEnd === 'number' ? el.selectionEnd : value.length;
  const selected = value.slice(start, end);

  let insertion = '';
  if (format === 'bold') insertion = `**${selected || 'bold text'}**`;
  if (format === 'italic') insertion = `*${selected || 'italic text'}*`;
  if (format === 'link') insertion = `[${selected || 'link text'}](https://example.com)`;
  if (!insertion) return;

  const next = `${value.slice(0, start)}${insertion}${value.slice(end)}`;
  setNativeElementValue(el, next);

  const cursorAt = start + insertion.length;
  el.focus();
  el.setSelectionRange(cursorAt, cursorAt);

  el.dispatchEvent(new Event('input', { bubbles: true }));
  el.dispatchEvent(new Event('change', { bubbles: true }));
};

export function TextFormatButtons({ disabled = false }) {
  return (
    <div className="pagebuilder-token-buttons__group" style={{ marginBottom: '0.5rem' }}>
      <span className="pagebuilder-token-buttons__title">Format</span>
      <button
        type="button"
        className="pagebuilder-block-action-btn pagebuilder-token-btn"
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => applyInlineFormatToActiveField('bold')}
        disabled={disabled}
        title="Bold"
      >
        <strong>B</strong>
      </button>
      <button
        type="button"
        className="pagebuilder-block-action-btn pagebuilder-token-btn"
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => applyInlineFormatToActiveField('italic')}
        disabled={disabled}
        title="Italic"
      >
        <em>I</em>
      </button>
      <button
        type="button"
        className="pagebuilder-block-action-btn pagebuilder-token-btn"
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => applyInlineFormatToActiveField('link')}
        disabled={disabled}
        title="Insert Link"
      >
        <i className="bi bi-link-45deg" aria-hidden="true" /> Link
      </button>
    </div>
  );
}

export function TokenInsertButtons({ onInsert }) {
  return (
    <div className="pagebuilder-token-buttons">
      <div className="pagebuilder-token-buttons__group">
        <span className="pagebuilder-token-buttons__title">Club info</span>
        {CLUB_INFO_TOKENS.map((item) => (
          <button
            key={item.token}
            type="button"
            className="pagebuilder-block-action-btn pagebuilder-token-btn"
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => onInsert(item.token)}
            title={item.token}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="pagebuilder-token-buttons__group">
        <span className="pagebuilder-token-buttons__title">Meeting info</span>
        {MEETING_INFO_TOKENS.map((item) => (
          <button
            key={item.token}
            type="button"
            className="pagebuilder-block-action-btn pagebuilder-token-btn"
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => onInsert(item.token)}
            title={item.token}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}
